var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.892,
    height: 25.959,
    viewBox: "0 0 26.892 25.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M58.581,38.112c-1.809,1.535-1.047,3.964-.306,5.343.933,1.713-.242,4.242-1.884,5.674A13.446,13.446,0,0,0,63.2,37.852a4.064,4.064,0,0,0-4.63.26",
    transform: "translate(-36.304 -23.982)",
    fill: "#23b2a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M23.548,48.3c-2.593-2.2-4.866-1.136-6.411.68s.595,2.394,3.562,3.067c2.23.506,1.955,3.533,2.159,4.214,2.661-4.3,1.895-6.956.712-7.961",
    transform: "translate(-10.7 -30.3)",
    fill: "#71be45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M44.925,5.644c4.424,3.434.534,5.186.534,5.186,2.493,2.137,5.051-1.952,7.779.381a5.728,5.728,0,0,1,1.524,2.173A13.457,13.457,0,0,0,45.249,1.63c-2.034.894-2.85,2.066-.324,4.021",
    transform: "translate(-27.91 -1.049)",
    fill: "#2cb5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M6.333,16.435c-1-2.743.271-4,4.63-7.106,5.5-3.918-3.106-2.529.4-6.055a29.378,29.378,0,0,1,4.274-3.1A13.777,13.777,0,0,0,13.453,0,13.453,13.453,0,0,0,0,13.45a8.169,8.169,0,0,0,.032.887c2.027,1.881,4.541,3.1,6.3,2.1",
    transform: "translate(0 0)",
    fill: "#1b4d4a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer 2.c2aa58e950dbe96b10ba9949a25dcac7.svg";
export { ForwardRef as ReactComponent };